









import PrototypesList from './PrototypesList.vue'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
    PrototypesList
  }
})
export default class PrototypesDisplay extends Vue {
  @Prop() editable!:any
  @Prop() report!:any
  @Prop() assetLoc!:any
  @Prop() drop!:any
  @Prop({ required: true }) displayOrder:number = 2000

  get prototypes ():any {
    // Get all prototypes from used questions
    const allPrototypes:any = {}
    var orphans = this.report.orphans
    processQuestions(orphans)
    var sections = this.report.sections
    if (sections) {
      sections.forEach(function (section:any) {
        processQuestions(section.questions)
      })
    }

    function processQuestions (questions:any):any {
      if (questions && questions.length) {
        questions.forEach(function (question:any):any {
          if (!question.export) {
            return
          }
          var protos = question.payload.prototypes
          if (protos) {
            Object.keys(protos).forEach(function (protoId:any):any {
              // Don't show prototypes without a URL (like text assets)
              if (!protos[protoId].url) {
                return
              }
              var proto = protos[protoId]
              if (!allPrototypes[proto.url]) {
                allPrototypes[proto.url] = proto
                allPrototypes[proto.url].includedIn = []
              }
              // Keep track of which cards the prototype was included in, may be helpful later
              allPrototypes[proto.url].includedIn.push(question.id)
            })
          }
        })
      }
    }
    return allPrototypes
  }
}
